export default __webpack_public_path__ + "static/media/chrome_scr.b0a71f11.png";